import { useEffect, useState } from "react";
import { Dimensions } from "react-native";
export const useKeyboardOpen = () => {
  const [originalViewPortHeight] = useState<number>(
    window?.visualViewport?.height ?? Dimensions.get("window").height,
  );
  const [currentViewPortHeight, setCurrentViewPortHeight] = useState<number>(
    originalViewPortHeight,
  );

  const updateCurrentViewPortHeight = () => {
    setCurrentViewPortHeight(
      window.visualViewport?.height ?? Dimensions.get("window").height,
    );
  };
  useEffect(() => {
    if (
      typeof window !== "undefined" &&
      typeof window.visualViewport !== "undefined"
    ) {
      window.visualViewport?.addEventListener(
        "resize",
        updateCurrentViewPortHeight,
      );

      return () =>
        window.visualViewport?.removeEventListener(
          "resize",
          updateCurrentViewPortHeight,
        );
    }
  }, []);

  return currentViewPortHeight < originalViewPortHeight;
};
